(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["probimel-home-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  const rootSelector = '[data-probimel-home-carousel]';
  const stateKey = '__probimelHomeManualState';

  function rootsIn(container) {
    const roots = [];
    if (container && typeof container.matches === 'function' && container.matches(rootSelector)) {
      roots.push(container);
    }
    if (container && typeof container.querySelectorAll === 'function') {
      container.querySelectorAll(rootSelector).forEach(function (root) { roots.push(root); });
    }
    return roots;
  }

  function enhance(root) {
    if (root[stateKey]) {
      root[stateKey].refresh();
      return;
    }
    const state = { observer: null, slider: null, refresh: null, destroy: null };
    root[stateKey] = state;

    function observeUntilReady() {
      if (state.observer) return;
      state.observer = new MutationObserver(refresh);
      state.observer.observe(root, { childList: true, subtree: true });
    }

    function refresh() {
      const slider = root.querySelector('.main-slider');
      if (window.jQuery && slider && state.slider !== slider) {
        if (state.slider) window.jQuery(state.slider).off('.probimelHomeManual');
        state.slider = slider;
        window.jQuery(slider).on('init.probimelHomeManual reInit.probimelHomeManual breakpoint.probimelHomeManual', refresh);
      }
      const previous = root.querySelector('.main-slider .arrow-prev.slick-arrow');
      const next = root.querySelector('.main-slider .arrow-next.slick-arrow');
      [[previous, 'Imagen anterior'], [next, 'Imagen siguiente']].forEach(function (pair) {
        if (!pair[0]) return;
        pair[0].setAttribute('role', 'button');
        pair[0].setAttribute('tabindex', '0');
        pair[0].setAttribute('aria-label', pair[1]);
      });
      if (previous && next) {
        if (state.observer) state.observer.disconnect();
        state.observer = null;
      } else {
        observeUntilReady();
      }
    }

    function onKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      if (!event.target || typeof event.target.closest !== 'function') return;
      const arrow = event.target.closest('.slick-arrow.arrow-prev, .slick-arrow.arrow-next');
      if (!arrow || !root.contains(arrow)) return;
      event.preventDefault();
      if (event.repeat || arrow.classList.contains('slick-disabled') || arrow.getAttribute('aria-disabled') === 'true') return;
      arrow.click();
    }

    state.refresh = refresh;
    state.destroy = function () {
      if (state.observer) state.observer.disconnect();
      if (state.slider && window.jQuery) window.jQuery(state.slider).off('.probimelHomeManual');
      root.removeEventListener('keydown', onKeydown);
      delete root[stateKey];
    };
    root.addEventListener('keydown', onKeydown);
    observeUntilReady();
    refresh();
  }

  function enhanceIn(container) { rootsIn(container).forEach(enhance); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhanceIn(document); }, { once: true });
  } else {
    enhanceIn(document);
  }
  document.addEventListener('shopify:section:load', function (event) { enhanceIn(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    rootsIn(event.target).forEach(function (root) { if (root[stateKey]) root[stateKey].destroy(); });
  });
}());

  } catch(e) { console.error(e); }
})();
})();
